var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input-box',{scopedSlots:_vm._u([{key:"label",fn:function(ref){
var classes = ref.classes;
return [(_vm.label)?_c('label',{class:classes},[_vm._v(_vm._s(_vm.label))]):_vm._e()]}}])},[_c('toast-ui-editor',{ref:"toastuiEditor",attrs:{"initial-value":_vm.value,"options":_vm.options,"name":_vm.name,"initial-edit-type":"wysiwyg"},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }